import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, isRef as _isRef, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "section-card" }
const _hoisted_2 = { class: "toolbar" }
const _hoisted_3 = { class: "toolbar-row" }
const _hoisted_4 = { class: "toolbar-left" }
const _hoisted_5 = { class: "count-badge" }
const _hoisted_6 = { class: "toolbar-row" }
const _hoisted_7 = { class: "sort-group" }
const _hoisted_8 = { class: "user-list" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "card-head" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "user-nick"
}
const _hoisted_13 = { class: "card-meta" }
const _hoisted_14 = {
  key: 0,
  class: "time"
}
const _hoisted_15 = {
  key: 1,
  class: "time"
}
const _hoisted_16 = { class: "card-foot" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  class: "empty-tip"
}
const _hoisted_20 = { class: "pagination-bar" }

import { NButton, NPagination, NSwitch } from 'naive-ui';
import { useRouter } from 'vue-router';
import { inject, ref, computed, type Ref } from 'vue';
import Tools from '@/ts/Tools';
import { resolveRoomName } from '@/ts/roomNameStore';
import { onlyOnline } from '@/ts/listFilterStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountList',
  props: {
    userList: {},
    totalCount: {},
    totalPages: {},
    currentPage: {},
    searchKeyword: {},
    sortBy: {},
    refreshingUser: {},
    refreshingAll: { type: Boolean }
  },
  emits: ["update:searchKeyword", "update:currentPage", "update:sortBy", "search", "pageChange", "refreshUser", "refreshAll", "modifyBalance", "toggleNoClear"],
  setup(__props: any, { emit: __emit }) {

const router = useRouter();
const debugMode = inject<Ref<boolean>>('debugMode', ref(false));

const props = __props;

// 在线主播优先置顶：在线(===true)排最前，未知/离线保持服务端原有顺序（稳定排序）；
// 开启“仅显示在线”时过滤掉非在线主播
const displayList = computed(() => {
  let arr = (props.userList ?? []).slice();
  if (onlyOnline.value) arr = arr.filter((v: any) => v?.online === true);
  return arr
    .map((v: any, i: number) => ({ v, i }))
    .sort((a, b) => {
      const ao = a.v?.online === true ? 1 : 0;
      const bo = b.v?.online === true ? 1 : 0;
      if (ao !== bo) return bo - ao;
      return a.i - b.i;
    })
    .map((x) => x.v);
});

const emit = __emit;

function goDetail(v: any) {
  router.push({
    name: 'accountDetail',
    params: { userName: v.userName },
    query: {
      online: v.online === true ? '1' : v.online === false ? '0' : '',
      room: v.room || '',
      ot: v.onlineTime || '',
      lo: v.lastOfflineTime || ''
    }
  });
}

function fmtTime(v: any): string {
  if (!v) return '';
  const d = new Date(v);
  if (isNaN(d.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "title" }, "📺 主播列表", -1)),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.totalCount) + "位主播", 1)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["online-filter", { on: _unref(onlyOnline) }])
        }, [
          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "of-dot" }, null, -1)),
          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "of-label" }, "仅显示在线", -1)),
          _createVNode(_unref(NSwitch), {
            value: _unref(onlyOnline),
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(onlyOnline) ? (onlyOnline).value = $event : null)),
            size: "small"
          }, null, 8, ["value"])
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_unref(NButton), {
            size: "tiny",
            type: _ctx.sortBy === 'credit' ? 'primary' : 'default',
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('update:sortBy', 'credit'))),
            ghost: ""
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode("💰 收益")
            ])),
            _: 1
          }, 8, ["type"]),
          _createVNode(_unref(NButton), {
            size: "tiny",
            type: _ctx.sortBy === 'id' ? 'primary' : 'default',
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('update:sortBy', 'id'))),
            ghost: ""
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode("📅 入驻")
            ])),
            _: 1
          }, 8, ["type"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayList.value, (v) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["user-card", v.online === true ? 'is-live' : 'is-offline']),
          key: v.userName
        }, [
          _cache[13] || (_cache[13] = _createElementVNode("span", { class: "card-accent" }, null, -1)),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", {
                class: _normalizeClass(["status-dot", { live: v.online === true, unknown: v.online == null }])
              }, null, 2),
              _createElementVNode("span", {
                class: "user-name",
                onClick: _withModifiers(($event: any) => (goDetail(v)), ["stop"])
              }, _toDisplayString(v.userName), 9, _hoisted_11),
              (v.nickname && v.nickname !== v.userName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(v.nickname), 1))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                class: _normalizeClass(["live-pill", { live: v.online === true, unknown: v.online == null }])
              }, _toDisplayString(v.online === true ? '直播中' : v.online === false ? '离线' : '未知'), 3)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", {
                class: _normalizeClass(["room", { ghost: !v.room }])
              }, "🏠 " + _toDisplayString(_unref(resolveRoomName)(v.room) || '未进房'), 3),
              (v.online && v.onlineTime)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, "上线 " + _toDisplayString(fmtTime(v.onlineTime)), 1))
                : (v.lastOfflineTime)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, "离线 " + _toDisplayString(fmtTime(v.lastOfflineTime)), 1))
                  : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", {
                class: _normalizeClass(["credit", { pulse: _ctx.refreshingUser === v.userName }])
              }, [
                _cache[10] || (_cache[10] = _createElementVNode("i", null, "💰", -1)),
                _createTextVNode(_toDisplayString(_unref(Tools).formatMoney(v.credit)), 1)
              ], 2),
              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "foot-gap" }, null, -1)),
              (_unref(debugMode))
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(["protect", { active: v.noClear }]),
                    onClick: _withModifiers(($event: any) => (emit('toggleNoClear', v)), ["stop"]),
                    title: "保护：勾选后不受数据清理影响"
                  }, _toDisplayString(v.noClear ? '🔒' : '🔓'), 11, _hoisted_17))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                class: _normalizeClass(["refresh", { spinning: _ctx.refreshingUser === v.userName }]),
                onClick: _withModifiers(($event: any) => (emit('refreshUser', v)), ["stop"]),
                title: "刷新收益"
              }, "⟳", 10, _hoisted_18),
              _createVNode(_unref(NButton), {
                size: "tiny",
                type: "primary",
                ghost: "",
                onClick: _withModifiers(($event: any) => (emit('modifyBalance', v)), ["stop"])
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode("调整")
                ])),
                _: 2
              }, 1032, ["onClick"])
            ])
          ])
        ], 2))
      }), 128)),
      (displayList.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _cache[14] || (_cache[14] = _createElementVNode("span", { class: "empty-icon" }, "📭", -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.userList.length === 0 ? '暂无主播数据' : '暂无在线主播'), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(_unref(NPagination), {
        page: _ctx.currentPage,
        "onUpdate:page": _cache[3] || (_cache[3] = ($event: any) => {emit('update:currentPage', $event); emit('pageChange', $event)}),
        "page-count": _ctx.totalPages,
        "page-slot": 7,
        size: "small"
      }, null, 8, ["page", "page-count"])
    ]),
    _createElementVNode("span", {
      class: _normalizeClass(["global-refresh", { spinning: _ctx.refreshingAll }]),
      onClick: _cache[4] || (_cache[4] = ($event: any) => (emit('refreshAll'))),
      title: "刷新全部主播收益"
    }, "⟳", 2)
  ]))
}
}

})